<template>
  <div id="search" v-show="show" class="open z-40">
    <button
      class="close rounded-lg text-white text-xlg"
      @click="$emit('close')"
    >
      ×
    </button>
   
     
    <input
      type="search"
      class="absolute input-search bg-gray-900 text-md md:text-lg border-b-2 focus:ring-0 w-full"
      placeholder="ادخل نصاً للبحث عنه.."
      v-model="text"
    />
    <button class="btn-bg rounded-lg text-white text-lg" @click="searchData">
       <svg
       v-show="loaded"
        class="inline mr-6 w-5 h-5 text-gray-200 animate-spin dark:text-yellow-600 fill-red-500"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span class="sr-only">Loading...</span>
    
      بحث
    </button>
  </div>
</template>

<script>
import { useSearchStore } from '@/stores/Search'
import { mapActions } from 'pinia'
export default {
  props: ['show'],
  data () {
    return {
      text: '',
      loaded: false,
      page: 1,
      limit: 10,
      active: this.show
    }
  },
  methods: {
    ...mapActions(useSearchStore, ['ShowSearchData']),
    async searchData () {
      if (this.text != '') {
        this.loaded = true
        try {
          await this.ShowSearchData(
            this.page,
            this.limit,
            this.text
          ).then(() => {
            this.$emit('close')
            this.loaded = false
            this.$router.push({ name: 'results',params:{
             
              query:this.text
         
            } })
          })
        } catch (error) {
          console.error('Failed to series  data', error)
        }
      }
    }
  }
}
</script>

<style scoped>
.results {
  margin-top: 280px;
  color: white;
  margin-left: 10%;

  width: 80%;
}
#search {
  position: fixed;
  z-index: 100000000000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-transform: translate(0px, -100%) scale(0, 0);
  -moz-transform: translate(0px, -100%) scale(0, 0);
  -o-transform: translate(0px, -100%) scale(0, 0);
  -ms-transform: translate(0px, -100%) scale(0, 0);
  transform: translate(0px, -100%) scale(0, 0);
  opacity: 0;
}

#search input[type='search'] {
  top: 40%;
  width: 80%;
  margin-left: 10%;
  color: white;
  background: rgba(0, 0, 0, 0);

  font-weight: 600;
  text-align: center;
  margin-top: -51px;
  padding-left: 5px;
  padding-right: 5px;
  outline: none;
  border: 0px solid;
  border-bottom: 1px solid;
}
input::placeholder {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

#search .close {
  position: fixed;
  top: 20px;
  right: 40px;
  color: #fff;

  opacity: 1;
  padding: 10px 17px;
  font-size: 30px;
}

#search .btn-bg {
  position: absolute;
  top: 40%;
  width: 80%;
  margin-left: 10%;
  color: #fff;
  background-color: #9d2890;
  border-color: #9d2890;
  opacity: 1;
  padding: 5px 10px;

  font-size: 20px;
}
#search.open {
  -webkit-transform: translate(0px, 0px) scale(1, 1);
  -moz-transform: translate(0px, 0px) scale(1, 1);
  -o-transform: translate(0px, 0px) scale(1, 1);
  -ms-transform: translate(0px, 0px) scale(1, 1);
  transform: translate(0px, 0px) scale(1, 1);
  opacity: 1;
}

@media (min-width: 768px) and (max-width: 1190px) {
  .pc_search {
    display: none;
  }
}

@media (min-width: 1191px) {
  #pc_search_small {
    display: none;
  }
}
</style>
